module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BZ-b7eb43cd67328427c676a34dd390a7b1.png";